import { CityLanguage } from '@/context/languages/languageData';
import { CitySpecialty } from '@/data/citySpecialties';
import { City } from '@/data/cities';

export const getLocalizedSpecialtyPath = (
  city: City,
  specialty: CitySpecialty,
  language: CityLanguage
): string => {
  const citySlug = city.slug;
  const specialtySlug = specialty.slugs[language] || specialty.slugs.en;
  
  // For English, use the default path
  if (language === 'en') {
    return `/city/${citySlug}/${specialtySlug}`;
  }
  
  // For other languages, use the localized path pattern
  return `/${language}/city/${citySlug}/${specialtySlug}`;
};

export const isLocalizedSpecialtyPath = (pathname: string): { 
  isLocalized: boolean; 
  language?: CityLanguage; 
  citySlug?: string;
  specialtySlug?: string;
} => {
  // Check for localized pattern: /lang/city/citySlug/specialtySlug
  const localizedMatch = pathname.match(/^\/([a-z]{2})\/city\/([^/]+)\/(.+)$/);
  if (localizedMatch) {
    return {
      isLocalized: true,
      language: localizedMatch[1] as CityLanguage,
      citySlug: localizedMatch[2],
      specialtySlug: localizedMatch[3]
    };
  }
  
  // Check for default English pattern: /city/citySlug/specialtySlug
  const englishMatch = pathname.match(/^\/city\/([^/]+)\/(.+)$/);
  if (englishMatch) {
    return {
      isLocalized: true,
      language: 'en',
      citySlug: englishMatch[1],
      specialtySlug: englishMatch[2]
    };
  }
  
  return { isLocalized: false };
};
